import React from 'react';

import { StateLabel } from '@common/components';
import { DisputeStateType } from '@common/graphql';

const DISPUTE_COLOR_STYLE_MAP: Record<DisputeStateType, string> = {
  open: 'sky-regular',
  rejected: 'coral',
  retracted: 'dark-grey',
  approved: 'grass-darkest',
  resolved: 'black',
  archived: 'dark-grey',
  redirected: 'sky-regular',
} as const;

export const DISPUTE_LABEL_OVERWRITE: Record<DisputeStateType, string> = {
  open: 'Open',
  rejected: 'Rejected',
  retracted: 'Retracted',
  approved: 'Approved',
  resolved: 'Resolved',
  archived: 'Archived',
  redirected: 'Open',
} as const;

const disputeStateLabel = (
  updatedBy: string | undefined
): Record<DisputeStateType, string> => ({
  ...DISPUTE_LABEL_OVERWRITE,
  redirected: `Open, Sent to ${updatedBy}`,
});

export const DisputeState = ({
  state,
  createdBy,
}: {
  state: DisputeStateType;
  createdBy?: 'Supplier' | 'Organization' | undefined;
}) => (
  <StateLabel
    state={disputeStateLabel(createdBy)[state] || state}
    color={DISPUTE_COLOR_STYLE_MAP[state]}
  />
);
